import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { FindingOverviewPage } from "@/features/findings/detail/overview/finding-overview-page";

export const Route = createFileRoute("/findings/$findingId")({
  validateSearch: z.object({
    view: z
      .enum([
        "overview",
        "investigation",
        "evidence",
        "decisions",
        "remediation",
        "verification",
        "history",
        "closure",
      ])
      .optional()
      .catch("overview"),
  }),
  component: () => (
    <PermissionGuard module="findings">
      <FindingOverviewPage />
    </PermissionGuard>
  ),
});
